import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function DailyWins({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData, isPromotionDataReady } = usePromotionsData();
	const data = useMemo(
		() => promotionsData.find((promo) => promo.title === "Daily Wins"),
		[promotionsData],
	);
	const [isMobile, setIsMobile] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// If the promo page is expired - throws error
	useEffect(() => {
		if (!isPromotionDataReady) return;

		if (!data) {
			navigate("/not-found");
		}
	}, [isPromotionDataReady, data, navigate]);

	if (!isPromotionDataReady || !data) return null;

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Daily Wins</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions{" "}
							</a>{" "}
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH ${data.title}`}
							/>
						</div>
						<div className="promotion-tnc-content">
							<div className="promotion-tnc-info">
								<div
									className={`promotion-indication-message ${data.promotionMessage.class}`}
								>
									{data.promotionMessage.text}
								</div>
								<h1>Daily Tournament & Weekly Wheel Drops</h1>
								<h2>
									Daily Wins will run from 30th March 2026 to 28th March 2027
									with total of ₱ 435,000,000 to be awarded across 12 levels.
								</h2>
								<div className="promotion-tnc-period">
									<strong>Promo Period: </strong>
									<span>March 30, 2026 - March 28, 2027</span>
								</div>
							</div>

							<div className="promotion-tnc-mechanic-content">
								<strong>Level 6: Weekly Wheel Drops</strong>
								<ul>
									<li>From: Mon, 24 August 2026, 20:00 (GMT+8)</li>
									<li>To: Mon, 28 September 2026, 19:59 (GMT+8)</li>
								</ul>

								<div className="table-wrapper">
									<table className="promotion-tnc-table daily-wins-table">
										<thead>
											<tr>
												<th colSpan={2}>Prize Pool</th>
											</tr>
										</thead>

										<tbody>
											<tr>
												<td>5</td>
												<td>29,000</td>
											</tr>

											<tr>
												<td>25</td>
												<td>14,500</td>
											</tr>

											<tr>
												<td>90</td>
												<td>x50 Free Spins</td>
											</tr>

											<tr>
												<td>280</td>
												<td>x20 Free Spins</td>
											</tr>

											<tr>
												<td>2,600</td>
												<td>x10 Free Spins</td>
											</tr>

											<tr>
												<td>20,000</td>
												<td>x8 Multiplier</td>
											</tr>

											<tr>
												<td>36,000</td>
												<td>x5 Multiplier</td>
											</tr>

											<tr>
												<td>20,000</td>
												<td>10 Free Chips</td>
											</tr>
										</tbody>
									</table>
								</div>

								<br />
								<strong>
									Level 6: Daily Tournaments – Largest Single Spin Win
								</strong>
								<ul>
									<li>From: Mon, 24 August 2026, 20:00 (GMT+8)</li>
									<li>To: Mon, 28 September 2026, 02:00 (GMT+8)</li>
								</ul>
								<div className="table-wrapper">
									<table className="promotion-tnc-table daily-wins-table">
										<thead>
											<tr>
												<th colSpan={2}>Prize Pool</th>
											</tr>
										</thead>

										<tbody>
											<tr>
												<td>1</td>
												<td>x500</td>
											</tr>

											<tr>
												<td>2 - 7</td>
												<td>x200</td>
											</tr>

											<tr>
												<td>8 - 20</td>
												<td>x50</td>
											</tr>

											<tr>
												<td>21 - 500</td>
												<td>x10</td>
											</tr>

											<tr>
												<td>501 - 4,500</td>
												<td>x5</td>
											</tr>
										</tbody>
									</table>
								</div>

								<strong>Level 7: Weekly Wheel Drops</strong>
								<ul>
									<li>From: Mon, 28 September 2026, 20:00 (GMT+8)</li>
									<li>To: Mon, 26 October 2026, 19:59 (GMT+8)</li>
								</ul>

								<div className="table-wrapper">
									<table className="promotion-tnc-table daily-wins-table">
										<thead>
											<tr>
												<th colSpan={2}>Prize Pool</th>
											</tr>
										</thead>

										<tbody>
											<tr>
												<td>5</td>
												<td>29,000</td>
											</tr>

											<tr>
												<td>25</td>
												<td>14,500</td>
											</tr>

											<tr>
												<td>90</td>
												<td>x50 Free Spins</td>
											</tr>

											<tr>
												<td>280</td>
												<td>x20 Free Spins</td>
											</tr>

											<tr>
												<td>2,600</td>
												<td>x10 Free Spins</td>
											</tr>

											<tr>
												<td>20,000</td>
												<td>x8 Multiplier</td>
											</tr>

											<tr>
												<td>36,000</td>
												<td>x5 Multiplier</td>
											</tr>

											<tr>
												<td>20,000</td>
												<td>10 Free Chips</td>
											</tr>
										</tbody>
									</table>
								</div>

								<br />
								<strong>
									Level 7: Daily Slot Tournaments – Largest Win From A Single
									Spin
								</strong>
								<ul>
									<li>From: Mon, 28 September 2026, 20:00 (GMT+8)</li>
									<li>To: Mon, 26 October 2026, 02:00 (GMT+8)</li>
								</ul>

								<div className="table-wrapper">
									<table className="promotion-tnc-table daily-wins-table">
										<thead>
											<tr>
												<th colSpan={2}>Prize Pool</th>
											</tr>
										</thead>

										<tbody>
											<tr>
												<td>1</td>
												<td>x500</td>
											</tr>

											<tr>
												<td>2 - 7</td>
												<td>x200</td>
											</tr>

											<tr>
												<td>8 - 20</td>
												<td>x50</td>
											</tr>

											<tr>
												<td>21 - 500</td>
												<td>x10</td>
											</tr>

											<tr>
												<td>501 - 4,500</td>
												<td>x5</td>
											</tr>
										</tbody>
									</table>
								</div>

								<br />

								<div className="promotion-tnc-cta">
									<a
										className="promotion-cta-btn"
										href="https://pp88.asia/tl/promotion/daily-wins/"
										target="_blank"
										rel="noreferrer"
									>
										View Full T&C
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
